import React from 'react';
import './BarChart.css';
import { FaTrainSubway } from 'react-icons/fa6';
import { FaCar } from 'react-icons/fa';
import { BsAirplaneFill } from 'react-icons/bs';
import { formatDuration } from '../../helpers/Functions.js';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { Colors } from 'helpers/Colors';
import { useMediaQuery, useTheme } from '@mui/material';
import { Typography } from '@mui/joy';

const CustomChart = ({ mode, index, sum, averages }) => {
    // @ts-ignore
    const emissionLabel = parseInt((mode.co2 * 100) / averages - 100)
    // Determine the width and height based on breakpoints
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.up('md'));
    const gaugeWidth = isXs ? 70 : isSm ? 70 : isMd ? 80 : 100;
    const gaugeHeight = isXs ? 70 : isSm ? 70 : isMd ? 80 : 100;
    return (
        <div className='bar-chart'>
            {/* <div className='bar-item'> */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", maxWidth: gaugeWidth }}>
                <Gauge width={gaugeWidth} height={gaugeHeight}
                    text={(emissionLabel > 0 ? "+" : "") + String(emissionLabel) + "%"} startAngle={-90} endAngle={90} value={Math.abs(emissionLabel)}
                    sx={{
                        [`& .${gaugeClasses.valueText}`]: {
                            transform: 'translate(0px, 0px)',
                            fontSize: gaugeHeight / 5,
                            color: 'red',
                        },
                        [`& .${gaugeClasses.valueArc}`]: emissionLabel > 0 ? {

                            fill: Colors.red,
                        } : {

                            fill: Colors.green,
                        },
                    }}
                />
                <div className="bar-item" >{mode.mode === 'Train 🚉' ? (
                    <FaTrainSubway color='#00008B' />
                ) : mode.mode === 'Driving 🚗' ? (
                    <FaCar color='#cc0000' />
                ) : (
                    <BsAirplaneFill color='#2196F3' />
                )}
                </div>

                <Typography
                    sx={{
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        fontSize: (isSm) ? '0.6rem' : '0.8rem', // Adjust font size for smaller screens
                        mb: 2,
                        mt: 1.5
                    }}
                >
                    {formatDuration(mode.duration)}
                </Typography>
            </div>
        </div>
    );
};

export default CustomChart;
